exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mat-card.team-card {\r\n  width: 320px;\r\n  float: left;\r\n  margin: 1rem;\r\n  position: relative;\r\n}\r\n\r\n.team-card mat-icon {\r\n  color: #3eb049;\r\n}\r\n\r\n.team-persona {\r\n  font-weight: 600;\r\n  color: #3d1951;\r\n}\r\n\r\n.team-partner {\r\n  cursor: pointer;\r\n}\r\n\r\n.team-partner-highlight {\r\n  background-color: #9ED5A4;\r\n  padding-left: 2px;\r\n  padding-right: 2px;\r\n}\r\n\r\n.team-tree mat-icon {\r\n  font-size: medium;\r\n}\r\n\r\n::ng-deep .ui-tree {\r\n  border: none;\r\n}\r\n\r\n/* Sets dialog max width for mobile, removes padding */\r\n\r\n::ng-deep mat-dialog-container.mat-dialog-container {\r\n  max-width: 100vw;\r\n  padding: 0px;\r\n  margin: 0;\r\n}\r\n\r\n@media screen and (min-width: 600px){\r\n  ::ng-deep mat-dialog-container.mat-dialog-container {\r\n    max-width: 80vw;\r\n    max-height: 70vh;\r\n    margin: 0 auto;\r\n    padding: 24px;\r\n  }\r\n}\r\n\r\n@media screen and (max-height: 600px){\r\n   ::ng-deep mat-dialog-container.mat-dialog-container {\r\n    height: 80vh;\r\n    position: relative;\r\n    top:40px;\r\n  } \r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/teams/team/team.component.css
// module id = ../../../../../src/app/teams/team/team.component.css
// module chunks = main